import * as home from './home/index';
import * as legal from './legal/index';
import { rootRoute } from './index';

const tree = rootRoute.addChildren([
  home.homeRoute,
  home.productsRoute,
  home.contactRoute,
  legal.terms,
  legal.privacy,
]);

export { tree };
